import type {ConversationDetail} from './conversation-pages.js';
/** Native group moderators may delete content; foreign shared representatives
 * need the separate canonical-host permission from the current server detail. */
export function canModerateMessages(detail:Pick<ConversationDetail,'type'|'role'|'shared_room'|'can_moderate_messages'>|null|undefined):boolean{
 return Boolean(detail?.type==='group'&&['owner','admin'].includes(detail.role)&&(!detail.shared_room||detail.can_moderate_messages===true));
}
